import React from 'react';
import classNames from 'classnames';

import 'index.css';
import './Controls.css';
import './PlayBtn.scss';

const PlayBtn = ({onPlay = null, playing, waitForPlay}) => (
  <span
    className={classNames('controls-play-btn', 'controls-btn', {playing, wait: waitForPlay})}
    onClick={playing ? null : onPlay}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="14.145" height="15.634" viewBox="0 0 14.145 15.634">
      <path
        id="Polygone_7"
        data-name="Polygone 7"
        d="M7.817,0l7.817,14.145H0Z"
        transform="translate(14.145) rotate(90)"
      />
    </svg>
  </span>
);
export default PlayBtn;
